import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-avatar-block>` displays an an avatar and line of text
 */
@Component({
  selector: 'labs-avatar-block-text',
  template: '<ng-content></ng-content>',
  styleUrls: ['./avatar-block-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarBlockTextComponent {}
